import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

const MS_SCOPES = [
  'Calendars.Read',
  'OnlineMeetings.Read',
  'OnlineMeetings.ReadWrite',
  'User.Read',
];

export const useMsalAuth = () => {
  const { instance, accounts } = useMsal();

  const acquireToken = useCallback(
    async (options?: { forceRefresh?: boolean }) => {
      if (accounts.length === 0) return null;

      try {
        const tokenRequest = {
          scopes: MS_SCOPES,
          account: accounts[0],
          ...(options?.forceRefresh ? { forceRefresh: true } : {}),
        };
        const tokenResponse = await instance.acquireTokenSilent(tokenRequest);
        return tokenResponse.accessToken;
      } catch (error) {
        console.error('Error acquiring MS token:', error);
        return null;
      }
    },
    [instance, accounts],
  );

  return {
    acquireToken,
    userEmail: accounts[0]?.username ?? '',
    userId: accounts[0]?.localAccountId ?? '',
    hasAccount: accounts.length > 0,
  };
};
